"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _reactI18next = require("react-i18next");
var _PaymentMethod = _interopRequireDefault(require("../../components/PaymentMethod"));
var _SectionHeader = _interopRequireDefault(require("../../components/SectionHeader"));
var _Transactions = _interopRequireDefault(require("../../components/Transactions"));
var _UpdatePaymentDetailsPopup = _interopRequireDefault(require("../../components/UpdatePaymentDetailsPopup"));
var _GracePeriodError = _interopRequireDefault(require("../../components/GracePeriodError"));
var _EditDeliveryDetailsPopup = _interopRequireDefault(require("../../components/EditDeliveryDetailsPopup"));
var _publisherConfigSlice = require("../../redux/publisherConfigSlice");
var _WithAddPaymentDetailsFinalizationHandler = _interopRequireDefault(require("../WithAddPaymentDetailsFinalizationHandler"));
var _popupSlice = require("../../redux/popupSlice");
var _store = require("../../redux/store");
var _PaymentInfoStyled = require("./PaymentInfoStyled");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable react/forbid-prop-types */

const PaymentInfo = _ref => {
  let {
    adyenConfiguration: adyenConfigurationProp,
    displayGracePeriodError
  } = _ref;
  const dispatch = (0, _store.useAppDispatch)();
  const adyenConfigurationStore = (0, _store.useAppSelector)(_publisherConfigSlice.selectAdyenConfiguration);
  const {
    isOpen,
    currentType
  } = (0, _store.useAppSelector)(_popupSlice.selectPopupDetails);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const paymentDetailsPopup = (0, _store.useAppSelector)(_popupSlice.selectPaymentDetailsPopup);
  const adyenConfiguration = adyenConfigurationProp || adyenConfigurationStore;
  const isEditDeliveryDetailsPopupOpened = isOpen && currentType === _popupSlice.POPUP_TYPES.EDIT_DELIVERY_DETAILS_POPUP;
  (0, _react.useEffect)(() => {
    dispatch((0, _publisherConfigSlice.init)({
      adyenConfiguration
    }));
    if (displayGracePeriodError !== null) {
      dispatch((0, _publisherConfigSlice.init)({
        displayGracePeriodError
      }));
    }
    return () => {
      dispatch((0, _popupSlice.updatePaymentDetailsPopup)({
        isOpen: false
      }));
    };
  }, []);
  if (isEditDeliveryDetailsPopupOpened) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_PaymentInfoStyled.WrapStyled, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_EditDeliveryDetailsPopup.default, {})
    });
  }
  if (paymentDetailsPopup.isOpen) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_PaymentInfoStyled.WrapStyled, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_GracePeriodError.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        "data-testid": "payment-info__update-payment-details-popup",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_UpdatePaymentDetailsPopup.default, {})
      })]
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_PaymentInfoStyled.WrapStyled, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_GracePeriodError.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)("section", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SectionHeader.default, {
        children: t('paymentinfo.current-payment-method', 'Current payment method')
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PaymentMethod.default, {})]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("section", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SectionHeader.default, {
        marginTop: "25px",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
          children: t('paymentinfo.payment-history', 'Payment history')
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Transactions.default, {})]
    })]
  });
};
var _default = exports.default = (0, _WithAddPaymentDetailsFinalizationHandler.default)(PaymentInfo);